<div class="flex flex-col p-6 max-w-[440px]">
  <div class="flex flex-col justify-center items-center">
    <ui-animation
      class="h-[100px] w-[100px] mb-4"
      type="success"
    ></ui-animation>
    <ui-headline
      class="text-center mb-3"
      type="h20"
      mobile-type="h16"
      text-color="primary-700"
      font-weight="semibold"
      [content]="title"
    ></ui-headline>
    <ui-paragraph
      class="text-center mb-6"
      type="p14"
      mobile-type="p12"
      text-color="neutrals-700"
      font-weight="regular"
      [content]="message"
    ></ui-paragraph>
  </div>

  <ui-button
    type="primary"
    responsive="false"
    size="lg"
    [attr.button-text]="buttonText"
    (clicked)="closeDialog()"
  ></ui-button>
</div>
